<template>
  <div>
    <template>
      <h4 class="not-margin" :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
        <i class="fal fa-users" :style="{ width: '25px', fontSize: '18px' }"></i>
        {{ $t('vipCustomer.edit_customer') }}
      </h4>
    </template>

    <div class="field" :style="{marginTop: '15px'}">
      <div class="control">
        <label class="label">
          {{ $t('vipCustomer.bank') }}
          <span class="text-danger">* {{ errors.first('bank_name') }}</span>
          <span class="text-danger">
                        {{ server_errors.bank_name }}
                    </span>
        </label>
        <select class="input" name="bank_name" v-model="listCustomer.bank_name"
                v-validate="'required'" @change="validateAccountNumber">
          <option value="">{{ $t('vipCustomer.select_bank_placeholder') }}</option>
          <option value="ທະນາຄານ BCEL">{{ $t('vipCustomer.bank_bcel') }}</option>
          <option value="ທະນາຄານ LDB">{{ $t('vipCustomer.bank_ldb') }}</option>
        </select>
      </div>
    </div>
    <div class="field" :style="{marginTop: '15px'}">
      <div class="control">
        <label class="label">
          {{ $t('vipCustomer.account_name') }}
          <span class="text-danger">* {{ errors.first('account_name') }}</span>
          <span class="text-danger">
                        {{ server_errors.account_name }}
                    </span>
        </label>
        <input class="input" name="account_name" type="text"
               :placeholder="$t('vipCustomer.account_name_placeholder')" v-model="listCustomer.account_name"
               v-validate="{required:true, max:255, regex: '^[A-Z0-9-_.() ,\s]*$'}"
        >
        <!--             v-validate="'required|max:225|regex:^[A-Z_.() ,\\s]*$'"> -->
      </div>
    </div>
    <div class="field" :style="{marginTop: '15px'}">
      <div class="control">
        <label class="label">
          {{ $t('vipCustomer.account_number') }}
          <span class="text-danger">* {{ errors.first('account_number') }}</span>
          <span class="text-danger">
                        {{ server_errors.account_number }}
                    </span>
        </label>
        <input class="input" name="account_number" type="text"
               :placeholder="$t('vipCustomer.account_number_placeholder')" v-model="listCustomer.account_number"
               v-validate="accountNumberValidation"
               @input="validateAccountNumber">
      </div>
    </div>

    <div ref="target" id="target" class="center">
      <div class="con-btns">
        <vs-button ref="button" flat @click="ValidateForm()" class="form-btn-loading" :loading="btnLoading">
          {{ $t('vipCustomer.edit_customer') }}
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import MixinsEditCustomer from '@/Mixins/Customer/Edit';
import {ValidateCustomer} from '@/Plugins/Validation/Validate-Customer';


export default {
  props: ['listCustomer'],

  mixins: [MixinsEditCustomer],

  computed: {
    accountNumberValidation() {
      const bankName = this.listCustomer.bank_name;

      if (bankName === 'ທະນາຄານ BCEL') {
        // BCEL: 13 or 18 digits
        return 'required|numeric|bcel_account_validation';
      } else if (bankName === 'ທະນາຄານ LDB') {
        // LDB: exactly 16 digits
        return 'required|numeric|ldb_account_validation';
      } else {
        // Default validation
        return 'required|numeric|min:13|max:18';
      }
    }
  },

  methods: {
    validateAccountNumber() {
      // Re-validate the account number field when bank changes or account number changes
      this.$nextTick(() => {
        this.$validator.validate('account_number');
      });
    }
  },

  created() {
    ValidateCustomer(this);

    // Add custom validation rule for BCEL account numbers
    this.$validator.extend('bcel_account_validation', {
      validate: (value) => {
        const length = value ? value.toString().length : 0;
        return length === 13 || length === 18;
      },
      getMessage: () => this.$t('vipCustomer.bcel_account_length_error')
    });

    // Add custom validation rule for LDB account numbers
    this.$validator.extend('ldb_account_validation', {
      validate: (value) => {
        const length = value ? value.toString().length : 0;
        return length === 16;
      },
      getMessage: () => this.$t('vipCustomer.ldb_account_length_error')
    });
  }
}
</script>
<style lang="scss" scoped>
.label-title {
  text-align: left;
  margin-top: -15px;
}

.box-list-permission {
  text-align: left;
  margin-top: 10px;
  background: rgba(var(--vs-gray-2), 1);
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  max-width: 368px;

  .permission {
    background: $primary-color;
    padding: 5px 5px 5px 5px;
    color: $white;
    border-radius: 5px;
    width: auto;
    margin: 3px;
    text-align: center;
    font-size: 14px;
  }
}

.text-filename {
  .type-file {
    color: $primary-color !important;
  }
}

.text-size {
  font-size: 14px;

  .size {
    color: $primary-color !important;
  }
}
</style>
